var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 17 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M5,4.5 C5,2.567 6.567,1 8.5,1 C10.433,1 12,2.567 12,4.5 C12,6.433 10.433,8 8.5,8 C6.567,8 5,6.433 5,4.5 Z M8.5,0 C6.01472,0 4,2.01472 4,4.5 C4,6.98528 6.01472,9 8.5,9 C10.9853,9 13,6.98528 13,4.5 C13,2.01472 10.9853,0 8.5,0 Z M4.5,12 C3.30653,12 2.16193,12.4741 1.31802,13.318 C0.474106,14.1619 0,15.3065 0,16.5 L0,18.5 C0,18.7761 0.223858,19 0.5,19 C0.776142,19 1,18.7761 1,18.5 L1,16.5 C1,15.5717 1.36875,14.6815 2.02513,14.0251 C2.6815,13.3687 3.57174,13 4.5,13 L12.5,13 C13.4283,13 14.3185,13.3687 14.9749,14.0251 C15.6313,14.6815 16,15.5717 16,16.5 L16,18.5 C16,18.7761 16.2239,19 16.5,19 C16.7761,19 17,18.7761 17,18.5 L17,16.5 C17,15.3065 16.5259,14.1619 15.682,13.318 C14.8381,12.4741 13.6935,12 12.5,12 L4.5,12 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnUser);
export default __webpack_public_path__ + "static/media/icn-user.e4cf2ca1.svg";
export { ForwardRef as ReactComponent };